import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'
// import { reducer as notificationsReducer } from 'reapop'

import reducerAuth from './reducers/reducerAuth'
import reducerCallAPI from './reducers/reducerCallAPI'
import userReducer from './reducers/user'
import axData from './reducers/axData'
import display from './reducers/display'

export default combineReducers({
    form: formReducer,
    // notifications: notificationsReducer(),
    authen: reducerAuth.authen,
    users: userReducer.users,
    user: userReducer.user,
    callAPI: reducerCallAPI.reducerCallAPI,
    errorList: reducerCallAPI.errorList, //Error list from API
    isLoading: reducerCallAPI.isLoading,

    resources: axData.resources,
    warehouses: axData.warehouses,
    scraps: axData.scraps,

    materials: axData.materials,

    tablesData: display.getTables,
    tableData: display.getTable,
    pdsmAxData: display.pdsmAxData,
    startTimeData: display.setStartTime,
    endTimeData: display.setEndTime,
    workerData: display.setWorker,
    reportFinishData: display.reportFinishData

})


// WEBPACK FOOTER //
// ./src/app/redux/reducers.js